<template>
  <div
    class="wrapper"
    v-if="vehicle"
  >
    <div class="content">
      <h1>{{ vehicle.label }}</h1>
      <div class="row">
        <vehicle-details-image
          class="block"
          :vehicle="vehicle"
        />
        <vehicle-details-info
          class="block"
          :vehicle="vehicle"
        />
      </div>
      <div
        v-if="vehicle.description"
        class="row"
      >
        <vehicle-details-description
          class="block"
          :description="vehicle.description"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VehicleDetailssLayout',
  components: {

    VehicleDetailsImage: () => import(/* webpackChunkName: "vehicledetails"  */ `./VehicleDetailsImage`),
    VehicleDetailsInfo: () => import(/* webpackChunkName: "vehicledetails"  */ `./VehicleDetailsInfo/VehicleDetailsInfo`),
    VehicleDetailsDescription: () => import(/* webpackChunkName: "vehicledetails"  */ `./VehicleDetailsDescription`),
  },
  created() {
    this.$store.dispatch('vehicles/GET_VEHICLE_LIST')
  },

  computed: {
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
      isProfileRequested: 'user/isGetProfileRequested',
    }),
    vehicle() {
      return this.$store.state.vehicles.list.allVehicles.find((car) => car.id === window.renaultRent.vehicle_id)
    },
    isReadyForGTMGeneration() {
      this.analytics()
      return this.vehicle.id !== undefined && this.isProfileRequested !== undefined
    },
    vehiclePrice() {
      return this.$store.state.vehicles.prices.allPrices[
        [this.vehicle.semi_clair]
      ]
    },
  },
  methods: {
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const eeAction = 'eeProductDetail'
      const loginStatus = this.isProfileRequested ? this.userIsLogged : 'N/A'
      const page = window.location.href
      const pageTitle = document.querySelector('head title')?.text
      const pageCategory = ''
      const products = [{
        brand: 'Renault',
        category: this.vehicle?.type.label === 'VP' ? 'tourism' : 'utilitaire',
        /* eslint-disable-next-line camelcase */
        id: this.vehicle?.semi_clair,
        name: this.vehicle?.label,
        /* eslint-disable-next-line camelcase */
        price: this.vehiclePrice?.price_per_day,
        /* eslint-disable-next-line camelcase */
        priceOnline: parseFloat(this.vehiclePrice?.total_no_discount?.value),
        /* eslint-disable-next-line camelcase */
        priceAgency: parseFloat(this.vehiclePrice?.total_ttc?.value),
        quantity: 1,
        variant: '',
      }]
      const payload = {
        eeAction,
        loginStatus,
        page,
        pageCategory,
        pageTitle,
        products,
      }
      // console.log(payload)
      window.dataLayer.push(payload)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

.wrapper {
  margin: auto;
  padding: 20px 0 0;

  @include teq-breakpoint($medium) {
    max-width: calc(100% - 186px);
  }

  & ::v-deep h2 {
    @include font-size(16px);

    color: $c-nevada;
    font-family: $f-graphie-book;
    font-weight: normal;
    margin: 0 0 10px;
    //text-transform: uppercase;
  }
}

h1 {
  color: black;
  font-family: $f-graphie-bold;
  font-weight: normal;
  margin-left: 20px;
  //text-transform: uppercase;

  @include font-size(20px);

  @include teq-breakpoint($medium) {
    margin-left: 0;
  }
}

.row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0 40px;

  @include teq-breakpoint($medium) {
    flex-direction: row;
  }
}

.block,
.row > ::v-deep section { //apparently functional components dont inherit classes
  margin: 0;
  width: 100%;

  @include teq-breakpoint($large) {
    max-width: calc(50% - 20px);
  }
}
</style>
